

















































































































import { Component, Vue } from "vue-property-decorator";
import { DxScheduler, DxResource } from "devextreme-vue/scheduler";
import { fichajes_empleado } from "@/shared/dtos/fichajes_empleado";
import fichajes_empleadoModule from "@/store/modules/fichajes_empleado-module";
import usuarioModule from "@/store/modules/usuario-module";
import tipos_fichajeModule from "@/store/modules/tipos_fichaje-module";
import centro_trabajoModule from "@/store/modules/centro_trabajo-module";
import { MessageService } from "@/shared/services/message-service";
import { GeneradorColoresDistintos } from "@/utils/GeneradorColoresDistintos";

@Component({
  components: {
    DxScheduler,
    DxResource,
  },
})
export default class calendario_fichajes extends Vue {
  public vistaSeleccionada: string = "month";
  public vistas = ["day", "week", "month"];
  public menuFecha: boolean = false;
  public fechaSeleccionada: string = new Date().toISOString().substr(0, 10);
  public fechaCalendario: Date = new Date();

  public fichajes: fichajes_empleado[] = [];
  public recursos: { id: number; text: string; color: string }[] = [];

  public dialogoEditar: boolean = false;
  public fichajeSeleccionado: fichajes_empleado = new fichajes_empleado();
  public tiposFichaje: { id: number; name: string }[] = [];
  public centrosTrabajo: { id: number; name: string }[] = [];
  public empleadoSeleccionado: number | null = null;
  public editingOptions = {
    allowAdding: true,
    allowUpdating: true,
    allowDeleting: true,
    allowResizing: false,
    allowDragging: false,
  };

  async mounted() {
    await this.cargarDatos();
  }

  public async cargarDatos() {
    await usuarioModule.getusuarios();
    this.recursos = usuarioModule.usuarios.map((u, i) => ({
      id: u.id,
      text: u.nombre,
      color: this.generarColor(i),
    }));

    if (!fichajes_empleadoModule.fichajes_empleados.length) {
      await fichajes_empleadoModule.getfichajes_empleados();
    }
    this.fichajes = fichajes_empleadoModule.fichajes_empleados;
    await tipos_fichajeModule.gettipos_fichajes();
    this.tiposFichaje = tipos_fichajeModule.tipos_fichajes.map((t) => ({
      id: t.id,
      name: t.nombre,
    }));

    await centro_trabajoModule.getcentro_trabajos_base();
    this.centrosTrabajo = centro_trabajoModule.centro_trabajos.map((c) => ({
      id: c.id,
      name: c.nombre,
    }));
  }

  get nombreUsuarioFichajeSeleccionado(): string {
    const usuario = this.recursos.find(
      (r) => r.id === this.fichajeSeleccionado.id_usuario
    );
    return usuario ? usuario.text : "";
  }

  get fichajesCalendario() {
    let fichajes = this.fichajes;

    if (this.empleadoSeleccionado) {
      fichajes = fichajes.filter(
        (f) => f.id_usuario === this.empleadoSeleccionado
      );
    }

    return fichajes.map((f) => {
      const emp = this.recursos.find((r) => r.id === f.id_usuario);
      let fechaEntrada = new Date(f.fecha_entrada);
      let fechaSalida = new Date(f.fecha_salida);
      if (fechaSalida < fechaEntrada) {
        fechaSalida = new Date();
      }
      var horas =
        f.fecha_entrada && f.fecha_salida
          ? (() => {
          const diffMs = fechaSalida.getTime() - fechaEntrada.getTime();
          const horas = Math.floor(diffMs / 3600000);
          const minutos = Math.floor((diffMs % 3600000) / 60000);
          return `[${horas}h${minutos > 0 ? " " + minutos + " min" : ""}]`;
        })()
          : "";
      return {
        id: f.id,
        titulo: emp ? emp.text + " " + horas : "Empleado" + " " + horas,
        fechaInicio: new Date(f.fecha_entrada),
        fechaFin: new Date(f.fecha_salida),
        descripcion: `Tipo: ${f.id_tipo_fichaje}, Centro: ${f.id_centro_trabajo}`,
        empleadoId: f.id_usuario,
      };
    });
  }
  get formatoEntrada(): string {
    return this.fichajeSeleccionado.fecha_entrada
      ? this.toDatetimeLocal(this.fichajeSeleccionado.fecha_entrada)
      : "";
  }
  set formatoEntrada(val: string) {
    this.fichajeSeleccionado.fecha_entrada = new Date(val);
  }

  get formatoSalida(): string {
    return this.fichajeSeleccionado.fecha_salida
      ? this.toDatetimeLocal(this.fichajeSeleccionado.fecha_salida)
      : "";
  }
  set formatoSalida(val: string) {
    this.fichajeSeleccionado.fecha_salida = new Date(val);
  }

  public async onAppointmentFormOpening(e: any): Promise<void> {
    e.cancel = true;
    const idFichaje = e.appointmentData.id;
    const fichaje = this.fichajes.find((f) => f.id === idFichaje);
    if (fichaje) {
      this.fichajeSeleccionado = Object.assign(
        new fichajes_empleado(),
        fichaje
      );
      this.dialogoEditar = true;
    }
  }
  private toDatetimeLocal(date: any): string {
    if (!date) return "";
    const d = typeof date === "string" ? new Date(date) : date;
    if (!(d instanceof Date) || isNaN(d.getTime())) return "";
    const pad = (n: number) => (n < 10 ? "0" + n : n);
    return (
      d.getFullYear() +
      "-" +
      pad(d.getMonth() + 1) +
      "-" +
      pad(d.getDate()) +
      "T" +
      pad(d.getHours()) +
      ":" +
      pad(d.getMinutes()) +
      ":" +
      pad(d.getSeconds())
    );
  }

  public async guardarEdicion(): Promise<void> {
    await fichajes_empleadoModule.modificarfichajes_empleado(
      this.fichajeSeleccionado
    );
    await this.cargarDatos();
    this.dialogoEditar = false;
  }

  public actualizarFecha(): void {
    this.fechaCalendario = new Date(this.fechaSeleccionada);
  }

  public generarColor(index: number): string {
    var generador = new GeneradorColoresDistintos();
    return generador.obtenerSiguienteColor(); // Genera un color distinto con una opacidad del 50%
  }

  public confirmarEliminacion(): void {
    MessageService.confirm(
      "¿Seguro que quieres eliminar este fichaje?",
      "Eliminar Fichaje",
      (confirmado: boolean) => {
        if (confirmado) {
          this.eliminarFichaje();
        }
      }
    );
  }

  public async eliminarFichaje(): Promise<void> {
    try {
      await fichajes_empleadoModule.eliminarfichajes_empleado(
        this.fichajeSeleccionado
      );
      MessageService.toastsuccesful("Fichaje eliminado correctamente.");
      await this.cargarDatos();
      this.dialogoEditar = false;
    } catch (error) {
      console.error("Error al eliminar fichaje:", error);
      MessageService.toast("Error al eliminar el fichaje.", "Error");
    }
  }
  public onAppointmentDeleting(e: any): void {
    e.cancel = true; // Detenemos la eliminación por defecto

    MessageService.confirm(
      "¿Estás seguro de que deseas eliminar este fichaje?",
      "Confirmar eliminación",
      async (confirmado: boolean) => {
        if (confirmado) {
          try {
            const fichaje = this.fichajes.find(
              (f) => f.id === e.appointmentData.id
            );
            if (fichaje) {
              await fichajes_empleadoModule.eliminarfichajes_empleado(fichaje);
              MessageService.toastsuccesful("Fichaje eliminado correctamente.");
              await this.cargarDatos();
            }
          } catch (err) {
            console.error("Error al eliminar fichaje:", err);
            MessageService.toast("Error al eliminar el fichaje.", "Error");
          }
        }
      }
    );
  }
}
